var _style, _g, _path, _circle, _circle2, _circle3, _circle4, _ellipse, _path2, _circle5, _ellipse2, _g2, _path3, _path4, _path5, _g3, _path6, _path7, _polygon, _polygon2, _rect, _rect2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g4, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g5, _path72, _path73, _path74, _path75, _circle6, _circle7, _path76, _g6, _ellipse3, _path77, _path78, _g7, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _circle8, _defs, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _rect3, _rect4, _rect5, _rect6, _path99, _path100, _g8, _path101, _g9, _path102, _path103, _path104, _path105, _g10, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _circle9, _ellipse4, _circle10, _path124, _circle11, _ellipse5, _circle12, _path125, _circle13, _circle14, _circle15, _path126, _line, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 500",
    style: {
      enableBackground: "new 0 0 650 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#XMLID_103_);}\r\n\t.st2{fill:url(#XMLID_104_);}\r\n\t.st3{fill:url(#XMLID_105_);}\r\n\t.st4{fill:url(#XMLID_106_);}\r\n\t.st5{fill:url(#XMLID_108_);}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st7{fill:url(#XMLID_110_);}\r\n\t.st8{fill:url(#XMLID_111_);}\r\n\t.st9{fill:url(#XMLID_112_);}\r\n\t.st10{fill:url(#XMLID_132_);}\r\n\t.st11{fill:url(#XMLID_134_);}\r\n\t.st12{fill:url(#XMLID_135_);}\r\n\t.st13{fill:#8FABD8;}\r\n\t.st14{fill:#FFA49A;}\r\n\t.st15{fill:#283770;}\r\n\t.st16{fill:url(#XMLID_136_);}\r\n\t.st17{fill:url(#XMLID_137_);}\r\n\t.st18{fill:#FF8189;}\r\n\t.st19{fill:url(#XMLID_138_);}\r\n\t.st20{fill:url(#XMLID_139_);}\r\n\t.st21{fill:#526EEE;}\r\n\t.st22{fill:url(#XMLID_140_);}\r\n\t.st23{fill:url(#XMLID_141_);}\r\n\t.st24{opacity:0.5;fill:url(#XMLID_142_);}\r\n\t.st25{fill:url(#XMLID_143_);}\r\n\t.st26{fill:url(#XMLID_144_);}\r\n\t.st27{fill:url(#XMLID_145_);}\r\n\t.st28{fill:url(#XMLID_146_);}\r\n\t.st29{fill:url(#XMLID_147_);}\r\n\t.st30{fill:#7EC4E0;}\r\n\t.st31{fill:none;stroke:#7EC4E0;stroke-miterlimit:10;}\r\n\t.st32{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st33{fill:#D99490;}\r\n\t.st34{fill:url(#XMLID_148_);}\r\n\t.st35{fill:url(#XMLID_149_);}\r\n\t.st36{fill:url(#XMLID_150_);}\r\n\t.st37{fill:url(#XMLID_151_);}\r\n\t.st38{opacity:0.5;fill:url(#XMLID_152_);}\r\n\t.st39{fill:url(#XMLID_153_);}\r\n\t.st40{fill:url(#XMLID_154_);}\r\n\t.st41{fill:url(#XMLID_155_);}\r\n\t.st42{fill:url(#XMLID_156_);}\r\n\t.st43{fill:url(#XMLID_157_);}\r\n\t.st44{fill:#F3B2AD;}\r\n\t.st45{fill:#203647;}\r\n\t.st46{fill:url(#XMLID_158_);}\r\n\t.st47{fill:url(#XMLID_159_);}\r\n\t.st48{fill:url(#XMLID_160_);}\r\n\t.st49{opacity:0.32;fill:#D76B66;}\r\n\t.st50{fill:url(#XMLID_162_);}\r\n\t.st51{fill:url(#XMLID_163_);}\r\n\t.st52{fill:url(#XMLID_164_);}\r\n\t.st53{opacity:0.5;fill:url(#XMLID_165_);}\r\n\t.st54{fill:url(#XMLID_166_);}\r\n\t.st55{fill:url(#XMLID_167_);}\r\n\t.st56{fill:url(#XMLID_168_);}\r\n\t.st57{fill:url(#XMLID_169_);}\r\n\t.st58{fill:url(#XMLID_170_);}\r\n\t.st59{fill:url(#XMLID_175_);}\r\n\t.st60{fill:url(#XMLID_176_);}\r\n\t.st61{fill:url(#XMLID_177_);}\r\n\t.st62{fill:url(#XMLID_178_);}\r\n\t.st63{fill:url(#XMLID_179_);}\r\n\t.st64{fill:url(#XMLID_180_);}\r\n\t.st65{fill:url(#XMLID_182_);}\r\n\t.st66{clip-path:url(#XMLID_183_);}\r\n\t.st67{fill:url(#XMLID_184_);}\r\n\t.st68{fill:#EBEEFD;}\r\n\t.st69{fill:#F3D0C2;}\r\n\t.st70{fill:#EEBAAD;}\r\n\t.st71{fill:#DB9C93;}\r\n\t.st72{fill:url(#XMLID_185_);}\r\n\t.st73{fill:url(#XMLID_186_);}\r\n\t.st74{fill:url(#XMLID_187_);}\r\n\t.st75{fill:url(#XMLID_188_);}\r\n\t.st76{fill:url(#XMLID_189_);}\r\n\t.st77{fill:url(#XMLID_190_);}\r\n\t.st78{fill:url(#XMLID_191_);}\r\n\t.st79{fill:url(#XMLID_192_);}\r\n\t.st80{fill:url(#XMLID_193_);}\r\n\t.st81{fill:url(#XMLID_194_);}\r\n\t.st82{fill:url(#XMLID_195_);}\r\n\t.st83{fill:url(#XMLID_196_);}\r\n\t.st84{fill:url(#XMLID_197_);}\r\n\t.st85{fill:url(#XMLID_198_);}\r\n\t.st86{fill:url(#XMLID_199_);}\r\n\t.st87{fill:url(#XMLID_200_);}\r\n\t.st88{fill:none;stroke:url(#XMLID_201_);stroke-width:1.186;stroke-miterlimit:10;}\r\n\t.st89{fill:url(#XMLID_202_);}\r\n\t.st90{fill:url(#XMLID_203_);}\r\n\t.st91{fill:url(#XMLID_204_);}\r\n\t.st92{fill:url(#XMLID_205_);}\r\n\t.st93{fill:url(#XMLID_206_);}\r\n\t.st94{fill:url(#XMLID_207_);}\r\n\t.st95{fill:url(#XMLID_208_);}\r\n\t.st96{fill:url(#XMLID_209_);}\r\n\t.st97{fill:url(#XMLID_212_);}\r\n\t.st98{fill:url(#XMLID_216_);}\r\n\t.st99{fill:url(#XMLID_254_);}\r\n\t.st100{fill:url(#XMLID_256_);}\r\n\t.st101{fill:url(#XMLID_261_);}\r\n\t.st102{fill:url(#XMLID_265_);}\r\n\t.st103{fill:url(#XMLID_267_);}\r\n\t.st104{fill:url(#XMLID_271_);}\r\n\t.st105{fill:#E9C886;}\r\n\t.st106{fill:url(#XMLID_272_);}\r\n\t.st107{fill:url(#XMLID_274_);}\r\n\t.st108{fill:url(#XMLID_275_);}\r\n\t.st109{fill:url(#XMLID_276_);}\r\n\t.st110{fill:url(#XMLID_277_);}\r\n\t.st111{fill:none;stroke:#232230;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st112{font-family:'Montserrat-ExtraBold';}\r\n\t.st113{font-size:88.0871px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_24_",
    y: 0,
    className: "st0",
    width: 650,
    height: 500
  })))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_99_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_181_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.6666,
    y1: -15951.1416,
    x2: 312.6666,
    y2: -16332.5029,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_226_",
    className: "st1",
    d: "M312.7,71.4c-140.6,0-254.6,114-254.6,254.6c0,41.4,9.9,80.4,27.4,114.9h454.4 c17.5-34.5,27.4-73.6,27.4-114.9C567.2,185.4,453.3,71.4,312.7,71.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.4653,
    y1: -15622.5674,
    x2: 141.4653,
    y2: -16003.9297,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_225_",
    className: "st2",
    cx: 141.5,
    cy: 91.9,
    r: 19.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.6915,
    y1: -15925.5498,
    x2: 502.6915,
    y2: -16005.4404,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_97_",
    className: "st3",
    cx: 502.7,
    cy: 117.2,
    r: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_101_",
    className: "st0",
    cx: 443,
    cy: 134.5,
    r: 4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 597.4653,
    y1: -16188.3604,
    x2: 597.4653,
    y2: -16569.7227,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_219_",
    className: "st4",
    cx: 597.5,
    cy: 374.8,
    r: 11.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_217_",
    transform: "matrix(0.5757 -0.8177 0.8177 0.5757 34.5757 557.4021)",
    className: "st0",
    cx: 554.3,
    cy: 245.4,
    rx: 18.3,
    ry: 18.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_215_",
    className: "st0",
    d: "M91.1,415.9c0,8.2-6.7,14.9-14.9,14.9s-14.9-6.7-14.9-14.9c0-8.2,6.7-14.9,14.9-14.9 S91.1,407.6,91.1,415.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.3334,
    y1: -16026.0244,
    x2: 54.3334,
    y2: -16407.3867,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_211_",
    className: "st5",
    cx: 54.3,
    cy: 293.6,
    r: 24.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_210_",
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -103.0364 75.0684)",
    className: "st0",
    cx: 137.2,
    cy: 296.5,
    rx: 14.8,
    ry: 14.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_54_",
    className: "st6",
    x1: 87.1,
    y1: 237.1,
    x2: 184.1,
    y2: 237.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_55_",
    className: "st6",
    x1: 527.2,
    y1: 340.2,
    x2: 624.2,
    y2: 340.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_56_",
    className: "st6",
    x1: 364.5,
    y1: 106.4,
    x2: 461.6,
    y2: 106.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st0",
    d: "M99.3,376.9h-3.7v-3.7c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1v3.7h-3.7c-0.5,0-1,0.4-1,1 c0,0.5,0.4,1,1,1h3.7v3.7c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1v-3.7h3.7c0.5,0,1-0.4,1-1C100.3,377.3,99.8,376.9,99.3,376.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 515.7542,
    y1: -16030.5449,
    x2: 538.2078,
    y2: -16006.5693,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st7",
    d: "M531,138.5h-5.6v-5.6c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5v5.6h-5.6 c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5h5.6v5.6c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5v-5.6h5.6 c0.8,0,1.5-0.7,1.5-1.5C532.5,139.2,531.8,138.5,531,138.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 561.9188,
    y1: -16303.4209,
    x2: 576.6689,
    y2: -16287.6709,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st8",
    d: "M571.9,414.9h-3.7v-3.7c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1v3.7h-3.7c-0.5,0-1,0.4-1,1 s0.4,1,1,1h3.7v3.7c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1v-3.7h3.7c0.5,0,1-0.4,1-1S572.5,414.9,571.9,414.9z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_63_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_297_",
    className: "st0",
    d: "M430.3,159.9v-10c0-1-0.8-1.8-1.8-1.8h-2.6c-0.8,0-1.4-0.5-1.6-1.3 c-0.9-3.9-2.4-7.6-4.5-10.8c-0.4-0.7-0.3-1.5,0.2-2.1l1.8-1.8c0.7-0.7,0.7-1.8,0-2.5l-7.1-7.1c-0.7-0.7-1.8-0.7-2.5,0l-1.8,1.8 c-0.5,0.5-1.4,0.6-2.1,0.2c-3.3-2.1-7-3.6-10.8-4.5c-0.7-0.2-1.3-0.8-1.3-1.6v-2.6c0-1-0.8-1.8-1.8-1.8h-10c-1,0-1.8,0.8-1.8,1.8 v2.6c0,0.8-0.5,1.4-1.3,1.6c-3.9,0.9-7.6,2.4-10.8,4.5c-0.7,0.4-1.5,0.3-2.1-0.2l-1.8-1.8c-0.7-0.7-1.8-0.7-2.5,0l-7.1,7.1 c-0.7,0.7-0.7,1.8,0,2.5l1.8,1.8c0.5,0.5,0.6,1.4,0.2,2.1c-2.1,3.3-3.6,7-4.5,10.8c-0.2,0.7-0.8,1.3-1.6,1.3h-2.6 c-1,0-1.8,0.8-1.8,1.8v10c0,1,0.8,1.8,1.8,1.8h2.6c0.8,0,1.4,0.5,1.6,1.3c0.9,3.9,2.4,7.6,4.5,10.8c0.4,0.7,0.3,1.5-0.2,2.1 l-1.8,1.8c-0.7,0.7-0.7,1.8,0,2.5l7.1,7.1c0.7,0.7,1.8,0.7,2.5,0l1.8-1.8c0.5-0.5,1.4-0.6,2.1-0.2c3.3,2.1,6.9,3.6,10.8,4.5 c0.7,0.2,1.3,0.8,1.3,1.6v2.6c0,1,0.8,1.8,1.8,1.8h10c1,0,1.8-0.8,1.8-1.8v-2.6c0-0.8,0.5-1.4,1.3-1.6c3.9-0.9,7.5-2.4,10.8-4.5 c0.7-0.4,1.5-0.3,2.1,0.2l1.8,1.8c0.7,0.7,1.8,0.7,2.5,0l7.1-7.1c0.7-0.7,0.7-1.8,0-2.5l-1.8-1.8c-0.5-0.5-0.6-1.4-0.2-2.1 c2.1-3.3,3.6-6.9,4.5-10.8c0.2-0.7,0.8-1.3,1.6-1.3h2.6C429.5,161.7,430.3,160.9,430.3,159.9z M389.6,178.4 c-13,0-23.5-10.5-23.5-23.5c0-13,10.5-23.5,23.5-23.5c13,0,23.5,10.5,23.5,23.5C413.1,167.9,402.5,178.4,389.6,178.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_298_",
    className: "st0",
    d: "M358.1,126.2v-5.7c0-0.6-0.5-1-1-1h-1.5c-0.4,0-0.8-0.3-0.9-0.7c-0.5-2.2-1.4-4.3-2.5-6.2 c-0.2-0.4-0.2-0.9,0.1-1.2l1-1c0.4-0.4,0.4-1,0-1.4l-4-4c-0.4-0.4-1-0.4-1.4,0l-1,1c-0.3,0.3-0.8,0.4-1.2,0.1 c-1.9-1.2-4-2-6.2-2.5c-0.4-0.1-0.7-0.5-0.7-0.9v-1.5c0-0.6-0.5-1-1-1h-5.7c-0.6,0-1,0.5-1,1v1.5c0,0.4-0.3,0.8-0.7,0.9 c-2.2,0.5-4.3,1.4-6.2,2.5c-0.4,0.2-0.9,0.2-1.2-0.1l-1-1c-0.4-0.4-1-0.4-1.4,0l-4,4c-0.4,0.4-0.4,1,0,1.4l1,1 c0.3,0.3,0.4,0.8,0.1,1.2c-1.2,1.9-2,4-2.5,6.2c-0.1,0.4-0.5,0.7-0.9,0.7h-1.5c-0.6,0-1,0.5-1,1v5.7c0,0.6,0.5,1,1,1h1.5 c0.4,0,0.8,0.3,0.9,0.7c0.5,2.2,1.4,4.3,2.5,6.2c0.2,0.4,0.2,0.9-0.1,1.2l-1,1c-0.4,0.4-0.4,1,0,1.4l4,4c0.4,0.4,1,0.4,1.4,0l1-1 c0.3-0.3,0.8-0.4,1.2-0.1c1.9,1.2,3.9,2,6.2,2.5c0.4,0.1,0.7,0.5,0.7,0.9v1.5c0,0.6,0.5,1,1,1h5.7c0.6,0,1-0.5,1-1V144 c0-0.4,0.3-0.8,0.7-0.9c2.2-0.5,4.3-1.4,6.2-2.5c0.4-0.2,0.9-0.2,1.2,0.1l1,1c0.4,0.4,1,0.4,1.4,0l4-4c0.4-0.4,0.4-1,0-1.4l-1-1 c-0.3-0.3-0.4-0.8-0.1-1.2c1.2-1.9,2-3.9,2.5-6.2c0.1-0.4,0.5-0.7,0.9-0.7h1.5C357.6,127.2,358.1,126.7,358.1,126.2z  M334.9,135.2c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8c6.5,0,11.8,5.3,11.8,11.8 C346.8,129.9,341.5,135.2,334.9,135.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 325,
    y1: -16275.498,
    x2: 325,
    y2: -16024.0928,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBE1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AED2ED"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st9",
    d: "M475.7,390.7H174.3c-11.5,0-20.7-9.3-20.7-20.7V175.6c0-11.5,9.3-20.7,20.7-20.7h301.4 c11.5,0,20.7,9.3,20.7,20.7V370C496.4,381.4,487.1,390.7,475.7,390.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_255_",
    className: "st0",
    d: "M488,176.5v174.9c0,3.2-2.6,5.8-5.8,5.8H167.8c-3.2,0-5.8-2.6-5.8-5.8V176.5 c0-7.7,6.2-13.9,13.9-13.9h298.2C481.8,162.6,488,168.8,488,176.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.9989,
    y1: -16321.9502,
    x2: 324.9989,
    y2: -16266.9551,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBE1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AED2ED"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_15_",
    className: "st10",
    points: "357.7,441 292.3,441 299.2,401.1 301,390.7 349,390.7 350.8,401.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.1589,
    y1: -16277.8066,
    x2: 350.8389,
    y2: -16277.8066,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBE1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AED2ED"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_9_",
    className: "st11",
    points: "350.8,401.1 299.2,401.1 301,390.7 349,390.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.9999,
    y1: -16329.0283,
    x2: 324.9999,
    y2: -16304.3057,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBE1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AED2ED"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_57_",
    x: 270.6,
    y: 432.4,
    className: "st12",
    width: 108.8,
    height: 8.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_34_",
    x: 223.5,
    y: 299.7,
    className: "st13",
    width: 202.9,
    height: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_316_",
    className: "st14",
    d: "M119.5,427.4l-0.9,5.9c0,0,4.9,1.5,6.9,0.5l1.6-5.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_313_",
    className: "st14",
    d: "M155.6,425.3l0.5,7.9c0,0,4.4,1.6,8.1-1l0.1-6.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_307_",
    className: "st15",
    d: "M156.1,432.4c0,0-1.9,3.1-0.4,8.1h21.2c0,0,0.8-3.7-3.3-4.5c-4-0.8-9.5-3.9-9.5-3.9 s-0.9,0.4-2.8,0.7C159.5,433.1,156.8,432.7,156.1,432.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_260_",
    className: "st15",
    d: "M118.6,433.3c0,0-0.5,1-1.2,3.3c-0.8,2.4-0.1,4-0.1,4h12.1c0,0,1-3,0-4.3 c-0.5-0.6-1.6-1.1-2.4-1.6c-0.9-0.6-1.5-1.1-1.5-1.1S121.6,434,118.6,433.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.7427,
    y1: -16308.9141,
    x2: 157.7427,
    y2: -16211.2012,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#141A5A"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_262_",
    className: "st16",
    d: "M145.6,321.2v26l6-4.2c0.6,7.4,1.7,16.5,2.8,29c-2.8,6.9-1,27.2-0.5,35.2 c0.6,8.1,1.7,21.9,1.7,21.9c5.5,1,8.7-0.2,8.7-0.2s0.5-11.2,0.8-15.8c0.3-4.5,1.9-31,3.2-38.2c0.6-3.2,1.1-23.4,1.4-38.1 c0.1-5.7-1-16.8-1-16.8L145.6,321.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.7894,
    y1: -16307.4131,
    x2: 135.7894,
    y2: -16207.4072,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#141A5A"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_228_",
    className: "st17",
    d: "M137,318.3c0,0-4.1,9.1-4.1,19.2c0,8.2-1.9,29.6-1.9,29.6s-4,10.8-6.3,21.5 c-2.3,10.7-5.9,40.4-5.9,40.4s5.5,1.4,8.1,0.5c0,0,7.9-23.1,10.9-31.8c3-8.7,6.5-23.8,7.3-27.6c1.1-5.5,7.6-33.2,7.6-33.2 l-0.5-15.9L137,318.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    className: "st14",
    d: "M161,262.4c-1.7-1.4-1.9-2.3-1.9-2.3c-0.2-0.7-0.3-1.9-0.3-3c-0.1-1.5-0.1-3-0.1-3.7 c0-0.2,0-0.4,0-0.4l1.1-0.8l-11.1-5c2.7,7.4,0.4,13.1,0.4,13.2l0,0c0,0-0.7,1.8-1.9,2.5c-1.7,1.1-3.1,1.4-4.6,2 c0,0,13.2,9.5,22.9-0.6C165.5,264.2,161.9,263.2,161,262.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_258_",
    className: "st18",
    d: "M153.1,251.9c0.2,0.3,1,5.1,5.8,7c-0.1-1.5-0.2-3.2-0.2-3.9L153.1,251.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.4798,
    y1: -16133.5811,
    x2: 167.4798,
    y2: -16112.8926,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#272E79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_229_",
    className: "st19",
    d: "M166.5,234.2c0,0,1.8-0.1,2.4,2c1,3.6-2.9,7.1-2.9,7.1L166.5,234.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_257_",
    className: "st14",
    d: "M150.9,249c1.7,5.4,8.7,9.1,11.7,8.1c3.8-1.3,5.2-10.8,4.9-12.2c-1-4.1-1-6.2-0.9-7.9 c0.2-3.1-2.8-7.5-9.7-6.7C150,231,143.9,236.9,150.9,249z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.0374,
    y1: 222.4663,
    x2: 657.6126,
    y2: 246.2162,
    gradientTransform: "matrix(-1 0 0 1 801.8407 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#272E79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_253_",
    className: "st20",
    d: "M142,235.6c-0.4-0.4-0.8-0.9-1-1.5c-1.6-4.3,3-8.1,6.5-6.3c0.9,0.5,1.5,1.1,2,1.9 c1.7,0.4,1.2,2.1,1.2,2.1l-0.2,0c0.3,1.4,0.2,2.5,0.2,2.5l-3,2.8c0,0-1,0.1-2.2-0.1l0.2,0.5C140.8,238.2,141.1,235.7,142,235.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_251_",
    className: "st21",
    d: "M144.1,237.1c0,0,0.2-5.4,6-6.6l-1.9,3.1L144.1,237.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 651.8404,
    y1: 225.8676,
    x2: 651.8404,
    y2: 246.5567,
    gradientTransform: "matrix(-1 0 0 1 801.8407 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#272E79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_249_",
    className: "st22",
    d: "M143.3,245.3c0.8,3,2.9,3.5,3.5,5c1,3,1.8,4.3,3.2,4.4c0.2-1.9-0.2-7.6-0.2-7.6 c-0.3-0.9-0.2-1.8,0-2.4c0.4-1,2.7-0.4,2.7-0.4c1.5,0.2,1.6-1.6,2.1-2.6c0.9-2,1-4.2,1-4.2c-0.5-4,3-8.2,0.5-8.6 C150.2,228.1,141,235.9,143.3,245.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_242_",
    className: "st14",
    d: "M166.6,289.7c0,0,9.2,21.6,14.8,21.1c3.8-0.4,7.1-4.1,10-7.4c2.9-3.3,5.2-6.1,5.2-6.1 l-11.1,2.2l-3.2-6.8l-2.1-5l-1.6-3.9L166.6,289.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.8431,
    y1: 262.3885,
    x2: 172.8431,
    y2: 323.4114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_289_",
    className: "st23",
    d: "M181.4,288.8c0,0-2,3.3-9.8,5.9c-1.2,0.4-2.5,0.8-3.9,1.1c0,0-0.3-3.3-0.9-5.6 c-0.2-0.7-0.4-1.5-0.6-2.3c-0.6-2.2-1.2-4.6-1.8-6.9c-1.2-4.6,3.5-13.5,3.1-16.1C172.5,266.9,181.4,288.8,181.4,288.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.9539,
    y1: -16167.9824,
    x2: 168.9539,
    y2: -16179.3232,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_285_",
    className: "st24",
    d: "M171.7,294.6c-1.2,0.4-2.5,0.8-3.9,1.1c0,0-0.3-3.3-0.9-5.6c-0.2-0.7-0.4-1.5-0.6-2.3 l5-1.7C171.3,286.2,171.1,290.3,171.7,294.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.6447,
    y1: 262.3885,
    x2: 153.6447,
    y2: 323.411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_269_",
    className: "st25",
    d: "M168.9,321.1c-16,5-26.9-0.4-31.9-2.8c0-0.2,5-11.8,4.9-18.5c-0.1-21.6-5.9-28.7-6-29.7 c-0.1-1.6,8.8-6.4,8.8-6.4s3.7,3,7.7,4.2c4.3,1.3,9,0.4,9.5-5.1c0,0,2.3,0.6,5.5,2c1.6,4.7,3.7,14.8,3.7,21.3 C171.2,287.3,166.5,299.9,168.9,321.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.9511,
    y1: 296.2051,
    x2: 125.8253,
    y2: 347.2071,
    gradientTransform: "matrix(0.9962 8.660000e-02 -8.660000e-02 0.9962 27.8624 -10.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st26",
    d: "M158,328.7l-34.2,13c-0.9,0.3-1.8-0.1-2.1-1l-8.7-22.8c-0.3-0.9,0.1-1.8,1-2.1l34.2-13 c0.9-0.3,1.8,0.1,2.1,1l8.7,22.8C159.3,327.4,158.9,328.3,158,328.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_100_",
    className: "st14",
    d: "M146.5,331.7c-0.2-0.5-1.6-1.8-2-2.4c-0.4-0.5-1.7-1.5-2.5-1.9c-0.7-0.4-2.4-2.4-2.4-2.4 l0,0c-0.3-1.5-0.7-3.4-1.2-5.5c-1.2-5.2-2.2-12.5-2.7-17.2c1.2-3.6,4.2-13.5,4.2-13.5l-10.6-4.3c0,0-3.6,13.1-3.8,15.1 c0,0.3-0.1,0.5-0.1,0.8c-0.5,3.4,2.5,12.9,6.1,20.3c1.4,2.9,2.7,5.5,3.7,7.5v0c0.2,1.5,0,4.6,0.8,5.8c0.7,1,1.5,2.2,2.2,2.5 c0.7,0.3,1.2,0.2,1.8-0.1c0.9,0,1.5-0.3,1.6-0.7c1.1-0.1,1.1-0.2,1.6-0.9c1.2,0,1.7-0.6,1.4-1.3c-0.2-0.5-1.5-2.6-1.5-2.6 s1.6,1.2,2.3,1.3C146,332.4,146.6,332.2,146.5,331.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.8269,
    y1: 262.3885,
    x2: 135.8269,
    y2: 323.4113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_213_",
    className: "st27",
    d: "M126.6,291.5c1.8,1.2,10.5,3.6,12.9,3c0.4-1,2.9-7.5,4.2-12.8c2-8.1,1.2-17.9,1.2-17.9 s-10.8,3.5-14.2,15.4C129.7,282.4,128.1,287,126.6,291.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 642.251,
    y1: 225.8677,
    x2: 642.251,
    y2: 246.5566,
    gradientTransform: "matrix(-1 0 0 1 801.8407 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#272E79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    className: "st28",
    d: "M153.5,229.1c0,0-2.9,4.7-1.4,8.4c1.2,0.5,2.6,3.3,2.6,6.2c8.1,0.6,13-4.4,12.7-7.8 C166.7,226.3,153.5,229.1,153.5,229.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_93_",
    className: "st14",
    d: "M152.6,244.5c0,0-0.7-2.6-2.6-1.7c-2.1,0.9-0.6,4,0.1,5.2c0.7,1.2,2,0.8,2.2,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.5989,
    y1: -16205.583,
    x2: 193.5989,
    y2: -16125.5801,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#141A5A"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    className: "st29",
    d: "M178.5,302.7h24.1c0.5,0,1-0.4,1.1-0.9l6.1-35.6c0.1-0.7-0.4-1.3-1.1-1.3h-24.1 c-0.5,0-1,0.4-1.1,0.9l-6.1,35.6C177.3,302.1,177.8,302.7,178.5,302.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st14",
    d: "M209,271.5c0,0,0.8,1.7,0.8,3.1c0,1.5-1.1,4.2-2.2,4.8c-1.1,0.5-3.3,0.5-3.8,0.3 c-0.5-0.2-0.6-0.6-0.6-0.6s-1.3-0.1-1.6-0.2c-0.8-0.4-0.4-1.1-0.4-1.1s-1,0-1.4-0.2c-0.4-0.3-0.5-1.1,0.1-1.6 c0.4-0.4,1.3-0.6,1.3-0.6s0-0.6,0.7-1.2c0.3-0.3,2-0.7,3.5-0.9C206.5,273.1,208.4,273.1,209,271.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_98_"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_161_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_392_",
    x: 403.7,
    y: 381.1,
    className: "st0",
    width: 68.3,
    height: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_218_",
    x: 456.6,
    y: 381.1,
    className: "st30",
    width: 15.4,
    height: 6.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_387_",
    className: "st31",
    x1: 417.4,
    y1: 387.3,
    x2: 417.4,
    y2: 440.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_333_",
    className: "st31",
    x1: 468.4,
    y1: 387.3,
    x2: 468.4,
    y2: 440.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_388_",
    className: "st31",
    x1: 468.4,
    y1: 428.2,
    x2: 417.4,
    y2: 428.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_389_",
    className: "st32",
    x1: 460.6,
    y1: 428.2,
    x2: 409.5,
    y2: 428.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_239_",
    className: "st32",
    x1: 409.5,
    y1: 387.3,
    x2: 409.5,
    y2: 440.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_273_",
    className: "st32",
    x1: 460.6,
    y1: 387.3,
    x2: 460.6,
    y2: 440.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_245_"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_381_",
    className: "st14",
    d: "M432.1,427.9l-1.5,5.3c0,0-4.9,1.5-6.9,0.5l0.7-6.2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_339_",
    className: "st15",
    d: "M423.9,432.3c0,0-0.3,1.2-0.8,2.5c-0.8,0.9-1.3,1.5-1.5,1.9c-1,1.7,0.1,3.7,0.1,3.7h11.2 c0,0,1-3,0-4.3c-0.5-0.6-2.2-3.3-2.2-3.3S427.7,433.1,423.9,432.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_268_",
    className: "st33",
    d: "M384.2,428.2l-0.9,4.6c0,0,2.8,1.2,7,1.1l1.6-4.9L384.2,428.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_430_",
    className: "st15",
    d: "M370.9,440.5h19.9c0,0,2.2-3.5-0.2-7.8c0,0-3.6,0.3-7.1-0.9c0,0-2.4,1.6-5.4,3.1 C375,436.5,370.3,437.9,370.9,440.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.654,
    y1: -16322.335,
    x2: 414.654,
    y2: -16275.3184,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#141A5A"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_428_",
    className: "st34",
    d: "M444,381.1h-19.3c-4.5,0.9-11.7,5.3-17.7,5.7c-1,7.1-3.4,13.7-5.8,19.7 c-2.4,5.8-7.4,18.2-9.3,23.9c-1.3-0.1-4.5-0.3-8-1.8c2.3-12.9,7.5-41.3,8.9-46.8c2-8,7-11.1,12.3-12.3c5-1.1,6.4-1.4,11.1-2.5 l12.6-2.9l14.8-3.6c0,0,0.3,1.9,0.6,4.5C446,372.6,445.8,378.1,444,381.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 445.3612,
    y1: -16301.9336,
    x2: 445.3612,
    y2: -16246.8975,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#141A5A"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    className: "st35",
    d: "M462.6,381.1h-6c0,0-2,4.4-13.2,5.6c-0.7,4.3-1.4,7.1-3.6,15.4c-1.3,5-8.2,29.1-8.2,29.1 c-4.1,0.7-7.8-0.8-7.8-0.8s1.9-37.2,2.5-42.8c0.2-2.1,1.4-9.8,1.8-11.7c1.2-5.3,5.2-7.5,5.6-7.7c0,0,2.3-0.7,4.7-1.2l12.6-2.9 l13.9-4.5c0,0,1.3,2.8,1.6,5.4C468,372.2,466.3,380.8,462.6,381.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_266_",
    className: "st33",
    d: "M428.3,316.2L415,329.4c0,0-4.1-2.3-10.2-5.6c-6.1-3.3-11-5-11-5l-1.6,3.2 c0,0,14,13.3,21.4,15.9c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.5,0.1,0.7,0.2l0,0c0.4,0.1,0.8,0.2,1.2,0.2c6.4,0.6,18.9-12.8,18.9-12.8 L428.3,316.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.9714,
    y1: 311.3052,
    x2: 401.9714,
    y2: 342.6552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#141A5A"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_264_",
    className: "st36",
    d: "M416,342.4h-20c-0.5,0-0.9-0.3-1-0.7L387,313c-0.2-0.6,0.3-1.3,1-1.3h20 c0.5,0,0.9,0.3,1,0.7l8.1,28.7C417.2,341.8,416.7,342.4,416,342.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.7892,
    y1: 308.0552,
    x2: 430.7892,
    y2: 365.564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_429_",
    className: "st37",
    d: "M441.8,322.9l-6.6,5.6l-3.4,2.9l-2.3,2c-6.2-5.1-9.6-9.4-9.6-9.4 c8.9-9.6,13.6-13.2,13.7-13.3C435,309.5,441.8,322.9,441.8,322.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.4742,
    y1: -16203.4111,
    x2: 433.4742,
    y2: -16214.9883,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_398_",
    className: "st38",
    d: "M435.2,328.5l-3.4,2.9c0.8-1.9,2.1-9.8,2.1-9.8l1,1L435.2,328.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.3946,
    y1: 308.0552,
    x2: 449.3946,
    y2: 365.5639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_417_",
    className: "st39",
    d: "M466.5,312.4c-0.1,3.5-2.5,30.7-2.3,38.5c0.2,4.6,1.8,11.2,1.8,11.9 c0,0.5-0.7,1.1-0.9,1.2c-1,0.6-2.8,0.9-5.1,1.2h0c-4.5,0.5-10.5,0.7-14.2,0.7c-4.9,0-12.3-0.8-13.2-2c-0.9-1.1-0.1-2.8,0.3-5.1 c3.1-16.8,0-44.6,0.5-48.1c2-1.3,11-4.2,11.1-4.2c1.3-0.1,1.6-0.7,3.1-0.7c1.3,0,4.3,0.2,6.5,0.5 C454.2,306.3,462.3,308.2,466.5,312.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_386_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.4508,
    y1: -16192.9834,
    x2: 436.4508,
    y2: -16174.4678,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#162959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_414_",
    className: "st40",
    d: "M433.9,288.1c0,0,0.6,7.5,3.1,8c2.5,0.5,1.9-2.7,1.9-2.7l-0.3-3.6L433.9,288.1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_416_",
    className: "st14",
    d: "M446.3,312.3c-4.9-0.2-3.2-4.5-1.6-5.9c0.1-0.1,0.1-0.3,0.1-0.5c0.1-1.2,0-3.8-0.1-5.2 c0-0.4-0.1-0.7-0.1-0.9l2.9-2l6-4.3c0,0,0.3,6.5,0.8,12.7C455,308.3,451.3,312.6,446.3,312.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_400_",
    className: "st18",
    d: "M450.1,299.7c0,0-1.6,5.1-5.3,6.2c0.1-1.2,0-3.8-0.1-5.2L450.1,299.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_410_",
    className: "st14",
    d: "M436.2,287.7c0,0-0.8,16,5,17.1c0,0,4.6,0.6,8.5-4.5c1.1-1.5,2.5-1.8,3-3.6 c0.7-2.9,1.8-8.3,0.5-11.5C451.1,280.5,436.3,276.4,436.2,287.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 443.0052,
    y1: -16181.373,
    x2: 443.0052,
    y2: -16162.8584,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#162959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_407_",
    className: "st41",
    d: "M453.1,283.6c1.5-6-6.9-11.6-17.8-3.3c-1.1-0.8-3.2-1.5-4.2-0.8c-1.2,0.8-1.4,3.9-0.7,6 c1.6,4.5,7.4,5.5,11.9,4.4c3.1-0.8,4.8-2.6,5.9-2.5c-1,4.4,1,8.1,2.5,7.8c0.2,0.4,1.2-1.2,1.2-0.7c0.1,1.1,1.1,3.1,2.3,0.8 C456,292.1,457.6,283.7,453.1,283.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_399_",
    className: "st14",
    d: "M451.7,298.6c2.2,0.5,4.5-6.2,1.7-6.5c-2.1-0.2-3,3.2-3,3.2S449.9,298.2,451.7,298.6z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_380_",
    className: "st14",
    d: "M477.5,341.3c0,0,0-0.1,0-0.1c-0.4-2.5-0.9-4.9-1.1-5.5c0-0.1,0-0.2,0-0.2 c-1.2-6.1-3.7-12-3.7-12l-10.1,5.1c0,0,2,8.4,4.1,14c0,0-8.1,6.8-13.3,10.7c-2.5,2-4.5,3.4-5.8,4.4c0,0-4.6,1.8-7.1,3.1 c-1,0.5-5.3,7.6-5.2,7.9c0.1,0.3,0.7,0.6,1.4,0.3c0.3-0.1,0.7-0.6,1.2-1.1c0,0-0.5,0.8-0.4,1c0.1,0.3,0.5,0.4,1,0.2 c0.5-0.2,0.9-0.7,1.4-1.5c-0.1,0.2-0.1,0.3-0.1,0.4c-0.1,0.2,0.4,0.7,1.3,0.2c0.7-0.3,1.7-2.5,2-2.8c0.1-0.1,0.5-0.3,1-0.4 l-1.2,3.8c0,0,0.1,0.4,1.2,0.2c0.9-0.2,2-2.8,2.5-4.3c3.5-0.3,4.6-4,4.6-4c3.8-2.3,10-4.4,17.5-7.6c3.1-1.3,6.1-3.5,7.5-4.3 c0.1,0,1-0.6,1-0.6c0.4-0.2,0.6-0.8,0.7-1.6c0,0,0,0,0,0C478,345.3,477.8,343.3,477.5,341.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.32,
    y1: 308.0552,
    x2: 467.32,
    y2: 365.5638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_384_",
    className: "st42",
    d: "M458.4,322.2c1.1,4.5,4.9,13.6,4.9,13.6c1.7,0.1,5.1-0.6,7.7-1.6c3.7-1.5,5.2-3.4,5.2-3.4 s-2.4-6.2-4.3-10.8c-1.3-3.2-3-6.2-3.8-6.9c-3.5-3.2-6.2-4-8.5-4.9L458.4,322.2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_314_",
    className: "st0",
    d: "M454.8,371.1h-16.9v-1.7h16.9c0.5,0,0.8,0.4,0.8,0.8l0,0 C455.6,370.7,455.2,371.1,454.8,371.1z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_270_",
    className: "st0",
    d: "M445.7,369.5l-8.6-31.1c-0.3-0.9-1.1-1.6-2-1.6h-41c-0.3,0-0.6,0.1-0.7,0.3l-1,0.8l0.8,0.5 l8.6,31c0.1,0.5,0.6,0.8,1.1,0.8h42.4C445.5,370.2,445.8,369.9,445.7,369.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.2705,
    y1: 333.0552,
    x2: 418.2705,
    y2: 379.7802
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_259_",
    className: "st43",
    d: "M444.1,371.1h-42.4c-0.5,0-1-0.3-1.1-0.8l-8.7-31.2c-0.2-0.7,0.3-1.4,1-1.4h41 c1,0,1.8,0.6,2,1.6l8.6,31.1C444.8,370.7,444.5,371.1,444.1,371.1z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_383_",
    className: "st33",
    d: "M392,318.2C392,318.2,392,318.2,392,318.2c0.2-0.3-0.1-1.3-1.3-1.7 c-1.4-0.5-1.7-0.6-1.7-0.6l-1.5-0.7l-0.4-1.6c0,0-1.4,2.4-1.4,3.1c0,0.7,1.3,3.8,2.5,4.4c1.2,0.6,2.9,1.3,3.4,1.3 c0.5,0,0.6-0.5,0.2-1c0.4,0.1,0.8,0.2,1,0.2c0.5,0,0.4-0.9-0.5-1.5c0.3,0.1,0.5,0.1,0.7,0.1C393.6,320,393.4,318.7,392,318.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_263_"
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_450_",
    className: "st44",
    d: "M537.3,435.1l-1.4-5.8c2.4,0.4,6.3-0.8,7.8-1l-0.2,6.8 C543.6,435.1,540.6,436.9,537.3,435.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_512_"
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_515_",
    className: "st45",
    d: "M502.7,319.1C502.7,319.1,502.7,319.1,502.7,319.1C502.7,319.1,502.7,319.1,502.7,319.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_514_",
    className: "st44",
    d: "M506.7,435.1l-0.3-4.4c2.4,0.4,5.2,0.2,6.7,0l-0.2,4.5C513,435.1,510,436.9,506.7,435.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 521.6752,
    y1: -16209.0049,
    x2: 521.6752,
    y2: -16314.9053,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#141A5A"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_442_",
    className: "st46",
    d: "M544.3,429.4c-1.6,0.9-6.4,1.7-8.7,0.9c0,0-10.3-46.6-11.6-52.3 c-1.7-7.5-4.7-16.5-6.5-24.7c0,4.2-0.4,9.7-0.8,14.4c0,0,0,0,0,0c-0.5,5.4-1,9.7-1,9.7c0.4,3.4,1.1,20-0.3,30.5 c-0.9,6.8-0.9,22.6-0.9,22.6c-1.8,0.4-5.4,0.8-9,0.1c0,0-5.6-52-5.9-56.1c-1-17-0.3-54.8-0.2-55.5c0,0.3,2,2,8,1.6 c8.3-0.5,23.9-1.6,23.9-1.6c4.6,2.6,5.4,15.8,5.3,22.2c-0.2,3,1.4,23.6,2.4,35.4c3,7.1,3,19.2,3.6,28.1 C543.5,418.7,544.3,429.4,544.3,429.4z"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_385_",
    className: "st44",
    d: "M494.7,281.8l-3.1,16.1c-3.9-3.1-9.9-7.8-13.9-10.1l-3.2,1.9c0,0,3.4,4.7,8.3,10 c6.3,6.9,9.7,9.7,9.7,9.7l0,0c0.9,0.8,2.1,1.1,4,0.1c6.1-3.3,9.6-22.9,9.6-22.9L494.7,281.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 500.139,
    y1: -16189.5811,
    x2: 500.139,
    y2: -16116.1992,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_509_",
    className: "st47",
    d: "M491,291.3c0,0,2.6,1.8,6.3,2.9c1,0.3,2.1,0.6,3.2,0.8c0.6,0.1,1.2,0.2,1.7,0.2 c0.8,0,1.6,0,2.5,0c0.3,0,0.5-0.1,0.8-0.1l2.1-8.7l1.6-6.4l-10.8-12.5C498.4,267.5,495.6,272.3,491,291.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_459_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 504.7179,
    y1: -16131.1299,
    x2: 504.7179,
    y2: -16112.2695,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#162959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_468_",
    className: "st48",
    d: "M502.6,233h2c0,0,0.1,0.6,0.2,1.3l2.3,1.4l0,3.7c0,0,0.3,3.3-2.2,2.6 c-1.5-0.5-1.8-3.3-1.7-5.6C501.7,235.3,502.6,233,502.6,233z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_467_",
    className: "st44",
    d: "M522,260.4c-0.5-1.1-0.9-15-0.9-15l-6.2,5.2L512,253c-0.3,1.5-0.8,3.3-1.3,4.8 c-0.5,1.5-0.2,2.9-0.2,2.9s1.3,2.3,4.2,2.1C520.4,262.4,522,260.4,522,260.4z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_466_",
    className: "st49",
    d: "M518.7,250.6c0,0-2.5,5.5-8,7.3c0.4-1.5,0.9-3.4,1.3-4.8l2.9-2.5L518.7,250.6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_465_",
    className: "st44",
    d: "M504.4,238.6c0,0-1.2,13,3,15.4c2.3,1.3,7.3,0.8,10.5-2.2c1.4-1.3,2.2-3.1,2.9-4.9 c1.1-2.9,2.7-8.4,1.7-11.9C521,230,505.8,227,504.4,238.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 513.6597,
    y1: -16131.2969,
    x2: 513.6597,
    y2: -16112.4375,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#162959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_464_",
    className: "st50",
    d: "M506,226.3c2.5-0.5,2.7-2.5,5.5-2.2c2.7,0.3,3.1,1.7,4.4,2.2c1.3,0.5,2.8,0.1,4.5,1.1 c1.1,0.6,1.4,1.8,1.6,2.5c5.1,0.8,4.6,4.3,3.4,8.2c-0.9,2.9,0.5,3.8-0.6,6c-0.5,0.9-1.7,2.3-1.9,3.5c-0.4,2-0.6,2.7-1.5,3.6 c-0.4-2.1-1.1-3.7-1.7-7.2c0-0.3-0.1-0.5-0.2-0.7c-1.9-0.2-3.1,0.2-3.5-1.1c-0.3-1.1-0.2-2.5-0.3-3.9c-4.4,0.3-5.5-1.5-6.1-1.9 c-4.7,1-6.5,0.6-7.7-1.1c-1.2-1.8-0.1-2.9-0.1-3.4c0,0,0,0,0,0C501.3,229.3,503.5,226.8,506,226.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 517.0395,
    y1: 258.3052,
    x2: 517.0395,
    y2: 327.8091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_458_",
    className: "st51",
    d: "M499.6,321.6c1.8,2.3,9,4.2,14.3,4.2c6,0,17.4-2.2,19.1-4.5c0.2-0.2,1.3-1.3-0.5-7.9 c-0.4-1.6-1.1-5.6-1.2-7c-0.5-7.9,1.8-18.9,2.6-21.3c2-6,4-10.9,3.2-15.7c-0.9-1.6-1.4-2.7-2.4-3.8c-2.5-2.7-11-6.7-13-7 c0,0-2,3.7-6.6,4c-5.7,0.4-4.6-4-4.6-4c-3.4,1.7-7.6,3.8-10.5,6.8c-2.4,2.4-4.2,8-2.7,18.3c0.5,3.2,1.3,15.3,1.7,25 C499.3,315.1,498.9,320.6,499.6,321.6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_456_",
    className: "st44",
    d: "M527.2,280c0,0,2.8,7.1,5.8,12.9c1,2,3,8.1,3.9,8.7c2.7,1.8,7.2-2.1,9-3.9 c0-0.1-0.6-4.2-2.1-9c-2.2-7.3-5.5-16.4-5.5-16.4L527.2,280z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.7896,
    y1: 258.3052,
    x2: 533.7896,
    y2: 327.8092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49A5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C6CEB"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_455_",
    className: "st52",
    d: "M525.5,266.6c1.5-1.9,6.3-4.6,9.6-0.6c0.6,0.8,4,6.5,5.7,11.4c1.8,5.1,3,9.1,3,9.1 s-3.3,1.7-6.7,2.9c-2.9,1-6.2,1.7-8.7,1.1c0,0-3.4-9-4.2-13.9C524.1,276.7,522.9,270,525.5,266.6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_403_",
    className: "st44",
    d: "M545.9,297.6c0,0-16-7-18.3-8.3c-3.5-2-5.6-3.4-6.8-4.2v0c0,0-2.7-5.2-3.4-6.4 c-0.7-1.3-3.3-1.6-5-2.7c-1.8-1.1-3.1-2.8-3.9-2.5c-0.8,0.3,0.3,2.6,1.2,3.3c0.9,0.7,2.8,2.2,2.8,2.2s-0.9,1.3-0.9,1.8 s-0.8,1.1-0.8,2s-0.5,1.4-0.3,2.3c0.2,0.9,1.1,2.7,1.5,3.2c0.2,0.2,0.7,0.1,0.9-0.2c0.2-0.3,0.3-0.8,0.3-1c0.1,0,1.6,2.2,4.3,2.5 c0.2,0,0.3,0,0.5,0c5.6,6.9,10.9,12,20.4,17.2C545.1,310.5,547,301.4,545.9,297.6z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_451_",
    className: "st15",
    d: "M502.4,434.7c0,0,3.1-2.5,4.1-2.5c0.8,0,1.2,0.5,1.9,0.8c0.5,0.2,1,0.2,1.1,0.2 c2.6,0,3.6-0.7,3.6-0.7c2.5,4.5,1,8.1,1,8.1h-19.9C493.6,435.9,499.9,435.5,502.4,434.7z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_449_",
    className: "st15",
    d: "M534.8,433.7c0,0,0.8-0.9,2.3-1.4c1.3-0.5,2.9-0.8,5.5,0.2c0.7,0,1.1-0.1,1.1-0.1 c0.2,0.7,0.6,1.2,1,1.7c3.8,4,1.6,6.5,1.6,6.5h-10.9C530.1,439.9,532.3,434.5,534.8,433.7z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_421_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_433_",
    className: "st44",
    d: "M518.1,248.2c3,1.6,5-5.9,2.1-6.7c-2.2-0.6-2.7,2.6-2.7,2.6S516.5,247.3,518.1,248.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 513.4266,
    y1: -16238.5605,
    x2: 513.9735,
    y2: -16221.7734,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#141A5A"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_423_",
    className: "st53",
    d: "M517.5,353.4c0,1.6,0,3.4-0.1,5.3l-4.8-16.6c-1.3-2-2.4-3.3-2.5-3.4l4.5,1.8 C515.2,344.1,517.5,353.4,517.5,353.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 487.0832,
    y1: 270.0552,
    x2: 487.0832,
    y2: 298.5552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#141A5A"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_240_",
    className: "st54",
    d: "M505.9,300.7h-22.1c-1.2,0-2.2-0.6-2.8-1.6l-13.9-25c-0.5-0.8,0.1-1.8,1.1-1.8h22.1 c1.2,0,2.2,0.6,2.8,1.6l13.9,25C507.5,299.7,506.9,300.7,505.9,300.7z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_382_",
    className: "st44",
    d: "M478.8,288.5c1-0.1,0.6-1.1-0.1-1.5c-0.3-0.2-0.8-0.4-1.3-0.5c0,0,0,0,0,0 c2,0.4,1.7-1,0.8-1.5c-1-0.5-3.5-1-3.5-1l-2.8-1.6l-1.3-2.3c0,0-0.6,2.9,0.1,4.1c0,0.5-0.1,1.4,0,1.6c0,0.1,0.2,0.2,0.3,0.3 c0.1,0.8,0.2,1.6,0.6,1.8c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.5,0.2,0.9,0.5,1.1c1,0.7,2.4,1.1,2.4,1.1s1.3,0.2,3,0.5 c1.4,0.2,1.4-0.4,1-0.9C479.8,289.9,479.5,289,478.8,288.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_517_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.7712,
    y1: 319.7219,
    x2: 336.7712,
    y2: 374.738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_214_",
    className: "st55",
    d: "M373.6,369.3h-73.7c-3.7,0-6.6-3-6.6-6.6v-30.1c0-3.7,3-6.6,6.6-6.6h73.7 c3.7,0,6.6,3,6.6,6.6v30.1C380.3,366.3,377.3,369.3,373.6,369.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_452_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_393_"
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_287_",
    className: "st0",
    cx: 307.4,
    cy: 339.3,
    r: 7.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.3929,
    y1: -16222.3574,
    x2: 307.3929,
    y2: -16209.9561,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBE1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AED2ED"
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_411_",
    className: "st56",
    cx: 307.4,
    cy: 336.9,
    r: 2.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.3917,
    y1: -16235.416,
    x2: 307.3917,
    y2: -16223.0146,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBE1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AED2ED"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_457_",
    className: "st57",
    d: "M312.4,344.9c-1.3,1.2-3.1,1.9-5,1.9c-1.9,0-3.7-0.7-5-1.9c0.1-2.7,2.3-4.9,5-4.9 c1.4,0,2.6,0.6,3.5,1.5C311.8,342.4,312.4,343.6,312.4,344.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_446_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_445_",
    className: "st0",
    d: "M346.3,336.9h-27.5c-0.5,0-0.9-0.4-0.9-0.9l0,0c0-0.5,0.4-0.9,0.9-0.9h27.5 c0.5,0,0.9,0.4,0.9,0.9l0,0C347.2,336.5,346.8,336.9,346.3,336.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_447_",
    className: "st0",
    d: "M346.3,340.2h-27.5c-0.5,0-0.9-0.4-0.9-0.9l0,0c0-0.5,0.4-0.9,0.9-0.9h27.5 c0.5,0,0.9,0.4,0.9,0.9l0,0C347.2,339.8,346.8,340.2,346.3,340.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_448_",
    className: "st0",
    d: "M331.2,343.5h-12.5c-0.5,0-0.9-0.4-0.9-0.9l0,0c0-0.5,0.4-0.9,0.9-0.9h12.5 c0.5,0,0.9,0.4,0.9,0.9l0,0C332.1,343.1,331.7,343.5,331.2,343.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_513_",
    className: "st0",
    d: "M335.7,343.5h-1.6c-0.5,0-0.9-0.4-0.9-0.9l0,0c0-0.5,0.4-0.9,0.9-0.9h1.6 c0.5,0,0.9,0.4,0.9,0.9l0,0C336.5,343.1,336.1,343.5,335.7,343.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_516_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_462_"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_510_",
    transform: "matrix(0.987 -0.1606 0.1606 0.987 -52.3782 63.4045)",
    className: "st0",
    cx: 366.1,
    cy: 355.8,
    rx: 7.5,
    ry: 7.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_170_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.1115,
    y1: 349.8435,
    x2: 278.1115,
    y2: 362.2451,
    gradientTransform: "matrix(-1 0 0 1 644.2611 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBE1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AED2ED"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_469_",
    className: "st58",
    d: "M363.7,353.4c0,1.3,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4 S363.7,352.1,363.7,353.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.1103,
    y1: 349.8437,
    x2: 278.1103,
    y2: 362.245,
    gradientTransform: "matrix(-1 0 0 1 644.2611 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBE1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AED2ED"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_463_",
    className: "st59",
    d: "M361.1,361.4c1.3,1.2,3.1,1.9,5,1.9c1.9,0,3.7-0.7,5-1.9c-0.1-2.7-2.3-4.9-5-4.9 c-1.4,0-2.6,0.6-3.5,1.5C361.7,358.9,361.2,360.1,361.1,361.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_453_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_461_",
    className: "st0",
    d: "M327.3,353.4h27.5c0.5,0,0.9-0.4,0.9-0.9l0,0c0-0.5-0.4-0.9-0.9-0.9h-27.5 c-0.5,0-0.9,0.4-0.9,0.9l0,0C326.4,353,326.8,353.4,327.3,353.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_511_",
    className: "st0",
    d: "M321.3,353.4h2.8c0.5,0,0.9-0.4,0.9-0.9l0,0c0-0.5-0.4-0.9-0.9-0.9h-2.8 c-0.5,0-0.9,0.4-0.9,0.9l0,0C320.4,353,320.8,353.4,321.3,353.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_460_",
    className: "st0",
    d: "M327.3,356.7h27.5c0.5,0,0.9-0.4,0.9-0.9l0,0c0-0.5-0.4-0.9-0.9-0.9h-27.5 c-0.5,0-0.9,0.4-0.9,0.9l0,0C326.4,356.3,326.8,356.7,327.3,356.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_454_",
    className: "st0",
    d: "M342.3,360h12.5c0.5,0,0.9-0.4,0.9-0.9l0,0c0-0.5-0.4-0.9-0.9-0.9h-12.5 c-0.5,0-0.9,0.4-0.9,0.9l0,0C341.4,359.6,341.8,360,342.3,360z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_520_"
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_518_",
    className: "st0",
    d: "M188.6,211.1h-73.3c-5.5,0-10-4.5-10-10l0,0c0-5.5,4.5-10,10-10h73.3c5.5,0,10,4.5,10,10 l0,0C198.6,206.6,194.1,211.1,188.6,211.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.2909,
    y1: -16083.3984,
    x2: 194.2907,
    y2: -16070.8984,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_519_",
    className: "st60",
    d: "M120.3,196.9l1,2.1c0.1,0.2,0.2,0.3,0.4,0.3l2.3,0.3c0.4,0.1,0.6,0.6,0.3,0.9l-1.7,1.6 c-0.1,0.1-0.2,0.3-0.2,0.5l0.4,2.3c0.1,0.4-0.4,0.8-0.8,0.6l-2.1-1.1c-0.2-0.1-0.3-0.1-0.5,0l-2.1,1.1c-0.4,0.2-0.8-0.1-0.8-0.6 l0.4-2.3c0-0.2,0-0.3-0.2-0.5l-1.7-1.6c-0.3-0.3-0.1-0.8,0.3-0.9l2.3-0.3c0.2,0,0.3-0.1,0.4-0.3l1-2.1 C119.5,196.5,120.1,196.5,120.3,196.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_177_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.7145,
    y1: -16085.9736,
    x2: 194.7145,
    y2: -16073.4736,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_521_",
    className: "st61",
    d: "M136.3,196.9l1,2.1c0.1,0.2,0.2,0.3,0.4,0.3l2.3,0.3c0.4,0.1,0.6,0.6,0.3,0.9l-1.7,1.6 c-0.1,0.1-0.2,0.3-0.2,0.5l0.4,2.3c0.1,0.4-0.4,0.8-0.8,0.6l-2.1-1.1c-0.2-0.1-0.3-0.1-0.5,0l-2.1,1.1c-0.4,0.2-0.8-0.1-0.8-0.6 l0.4-2.3c0-0.2,0-0.3-0.2-0.5l-1.7-1.6c-0.3-0.3-0.1-0.8,0.3-0.9l2.3-0.3c0.2,0,0.3-0.1,0.4-0.3l1-2.1 C135.6,196.5,136.1,196.5,136.3,196.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_178_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.1383,
    y1: -16088.5498,
    x2: 195.138,
    y2: -16076.0498,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_522_",
    className: "st62",
    d: "M152.4,196.9l1,2.1c0.1,0.2,0.2,0.3,0.4,0.3l2.3,0.3c0.4,0.1,0.6,0.6,0.3,0.9l-1.7,1.6 c-0.1,0.1-0.2,0.3-0.2,0.5l0.4,2.3c0.1,0.4-0.4,0.8-0.8,0.6l-2.1-1.1c-0.2-0.1-0.3-0.1-0.5,0l-2.1,1.1c-0.4,0.2-0.8-0.1-0.8-0.6 l0.4-2.3c0-0.2,0-0.3-0.2-0.5l-1.7-1.6c-0.3-0.3-0.1-0.8,0.3-0.9l2.3-0.3c0.2,0,0.3-0.1,0.4-0.3l1-2.1 C151.7,196.5,152.2,196.5,152.4,196.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_179_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.5619,
    y1: -16091.125,
    x2: 195.5617,
    y2: -16078.625,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_523_",
    className: "st63",
    d: "M168.5,196.9l1,2.1c0.1,0.2,0.2,0.3,0.4,0.3l2.3,0.3c0.4,0.1,0.6,0.6,0.3,0.9l-1.7,1.6 c-0.1,0.1-0.2,0.3-0.2,0.5l0.4,2.3c0.1,0.4-0.4,0.8-0.8,0.6l-2.1-1.1c-0.2-0.1-0.3-0.1-0.5,0l-2.1,1.1c-0.4,0.2-0.8-0.1-0.8-0.6 l0.4-2.3c0-0.2,0-0.3-0.2-0.5l-1.7-1.6c-0.3-0.3-0.1-0.8,0.3-0.9l2.3-0.3c0.2,0,0.3-0.1,0.4-0.3l1-2.1 C167.7,196.5,168.3,196.5,168.5,196.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_180_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.9853,
    y1: -16093.7012,
    x2: 195.9853,
    y2: -16081.2012,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_524_",
    className: "st64",
    d: "M184.6,196.9l1,2.1c0.1,0.2,0.2,0.3,0.4,0.3l2.3,0.3c0.4,0.1,0.6,0.6,0.3,0.9l-1.7,1.6 c-0.1,0.1-0.2,0.3-0.2,0.5l0.4,2.3c0.1,0.4-0.4,0.8-0.8,0.6l-2.1-1.1c-0.2-0.1-0.3-0.1-0.5,0l-2.1,1.1c-0.4,0.2-0.8-0.1-0.8-0.6 l0.4-2.3c0-0.2,0-0.3-0.2-0.5l-1.7-1.6c-0.3-0.3-0.1-0.8,0.3-0.9l2.3-0.3c0.2,0,0.3-0.1,0.4-0.3l1-2.1 C183.8,196.5,184.4,196.5,184.6,196.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_182_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.2205,
    y1: 121.5552,
    x2: 240.2205,
    y2: 185.1518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_525_",
    className: "st65",
    d: "M259.7,180.2h-39.1c-3.8,0-6.9-3.1-6.9-6.9v-49.2c0-3.8,3.1-6.9,6.9-6.9h39.1 c3.8,0,6.9,3.1,6.9,6.9v49.2C266.7,177.1,263.6,180.2,259.7,180.2z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_530_",
    className: "st0",
    cx: 240.4,
    cy: 148.2,
    r: 19.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_528_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_527_",
    cx: 240.4,
    cy: 148.2,
    r: 19.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_183_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_527_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_533_",
    className: "st66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_526_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_184_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.2337,
    y1: 132.8052,
    x2: 240.2337,
    y2: 163.3422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#272E79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_613_",
    className: "st67",
    d: "M253.2,156c-12.7,4-22.5,1.3-25.9,0.1c0.8-3,1.6-5.7,1.7-7.5c0.1-4-1.3-5.3-0.6-10.2 c0.6-4.1,2.6-5.9,3.2-6.4c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.2-0.1,0.3-0.2,0.4-0.3c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1,0 c0,0,0,0,0,0c2-1.3,4.4-2.2,7.3-2.2c2.6,0,3.8,1.6,3.8,1.6c1.5-0.4,2.9-0.3,4.1,0.3h0c0.1,0,0.7,0.3,0.7,0.3 c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.4,0.3c0.5,0.3,1.5,1.2,2.6,2.7c0,0,0,0,0,0c0.2,0.3,1.4,2.3,1.2,4.9 c-0.2,2.9-1.4,6.3-1.6,8.5C250.9,149.5,250.4,152.6,253.2,156z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_541_",
    className: "st68",
    d: "M254.8,162.4l-1.3,10.3H227l-1.3-10.3c3.4-1.9,7.3-2.4,7.9-2.6c0,0,0.1,0,0.1,0 c2.7-0.2,5.2-0.5,6.6-1c1.4,0.4,3.9,0.8,6.6,1C247.1,159.9,251.2,160.4,254.8,162.4z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_529_",
    className: "st69",
    d: "M246.8,159.8c-0.6-0.1-1.3-0.4-1.8-0.8c-0.5-0.4-0.9-1-1-1.6l-0.8-6.8h-3.1h-3.1 l-0.8,6.8c-0.1,0.6-0.5,1.2-1,1.6c-0.5,0.4-1.2,0.7-1.8,0.9c0,0,2.5,7,6.7,7C243.9,166.8,246.8,159.8,246.8,159.8z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_549_",
    className: "st70",
    d: "M231.8,145.2c0,0-0.6-0.5-1.3,0c-0.8,0.5,0.1,3.6,0.9,4.1c0.9,0.5,1.3-0.1,1.3-0.1 L231.8,145.2z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_547_",
    className: "st70",
    d: "M248.4,145.2c0,0,0.6-0.5,1.3,0c0.8,0.5-0.1,3.6-0.9,4.1c-0.9,0.5-1.3-0.1-1.3-0.1 L248.4,145.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_545_",
    className: "st69",
    d: "M240.2,132.1c0,0-8.9,0.6-8.8,9.7c0,0,0.3,6.7,1.5,8.8c1.2,2,3.4,5.4,7.3,5.5 c3.9-0.1,6.1-3.5,7.3-5.5c1.2-2,1.5-8.8,1.5-8.8C249.1,132.7,240.2,132.1,240.2,132.1z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_543_",
    className: "st71",
    d: "M244,154.7c0,0-0.4,0.4-1.1,0.8c-0.3,0.2-0.8,0.4-1.2,0.6c-0.5,0.2-1,0.3-1.6,0.3 c-0.3,0-0.5,0-0.8-0.1c-0.3,0-0.5-0.1-0.8-0.2c-0.5-0.2-0.9-0.4-1.2-0.6c-0.7-0.4-1.1-0.8-1.1-0.8s0.5,0.3,1.2,0.5 c0.4,0.2,0.8,0.3,1.2,0.4c0.2,0.1,0.5,0.1,0.7,0.1c0.2,0,0.5,0.1,0.7,0.1c1,0,2-0.3,2.7-0.6C243.6,155,244,154.7,244,154.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_185_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.8702,
    y1: 132.8052,
    x2: 240.8702,
    y2: 163.3421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#272E79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B1B38"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_540_",
    className: "st72",
    d: "M250.1,137.1c0,0-2.1-3.7-2.4-3.8c-0.3-0.1-1-0.3-1.7-0.6c-0.7-0.3-2.3-0.9-2.7-0.9 c-0.3,0-1.5,0.1-1.6,0.4c0,0,0,0.1,0,0.1c-0.7-0.4-1.5-0.8-1.6-0.8c-0.4,0.1-4.4,1.3-4.4,1.3s-1.9,1.7-2.5,2.1 c-0.6,0.4-1.7,3.1-1.7,3.1l-0.7,5.3c0,0,3.4-0.1,6.9-1.5c3.8-1.5,4.4-3,5-4.5c0.2,0.2,2.2,5.3,7.4,6 C252.2,143.5,250.1,137.1,250.1,137.1z"
  }))))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_535_",
    className: "st0",
    d: "M293.1,111h-39c-3.9,0-7.3,3-7.4,6.9c-0.1,4,3.1,7.3,7.1,7.3h3.3v4.7c0,0.6,0.7,0.8,1.1,0.4 l5.1-5.1h29.5c3.9,0,7.3-3,7.4-6.9C300.4,114.3,297.2,111,293.1,111z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_532_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_186_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.5925,
    y1: -16000.2998,
    x2: 293.9258,
    y2: -15993.3828,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_531_",
    className: "st73",
    d: "M257.2,114.4l0.8,1.6c0.1,0.2,0.2,0.3,0.4,0.3l1.8,0.3c0.4,0.1,0.6,0.6,0.3,0.9l-1.3,1.3 c-0.1,0.1-0.2,0.3-0.2,0.5l0.3,1.8c0.1,0.4-0.4,0.8-0.8,0.6l-1.6-0.8c-0.2-0.1-0.3-0.1-0.5,0l-1.6,0.8c-0.4,0.2-0.8-0.1-0.8-0.6 l0.3-1.8c0-0.2,0-0.3-0.2-0.5l-1.3-1.3c-0.3-0.3-0.1-0.8,0.3-0.9l1.8-0.3c0.2,0,0.3-0.1,0.4-0.3l0.8-1.6 C256.4,114,257,114,257.2,114.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_187_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.9283,
    y1: -16002.21,
    x2: 294.2617,
    y2: -15995.293,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_534_",
    className: "st74",
    d: "M268.4,114.4l0.8,1.6c0.1,0.2,0.2,0.3,0.4,0.3l1.8,0.3c0.4,0.1,0.6,0.6,0.3,0.9l-1.3,1.3 c-0.1,0.1-0.2,0.3-0.2,0.5l0.3,1.8c0.1,0.4-0.4,0.8-0.8,0.6l-1.6-0.8c-0.2-0.1-0.3-0.1-0.5,0l-1.6,0.8c-0.4,0.2-0.8-0.1-0.8-0.6 l0.3-1.8c0-0.2,0-0.3-0.2-0.5l-1.3-1.3c-0.3-0.3-0.1-0.8,0.3-0.9l1.8-0.3c0.2,0,0.3-0.1,0.4-0.3l0.8-1.6 C267.6,114,268.2,114,268.4,114.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_188_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.2642,
    y1: -16004.1201,
    x2: 294.5976,
    y2: -15997.2031,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_537_",
    className: "st75",
    d: "M279.6,114.4l0.8,1.6c0.1,0.2,0.2,0.3,0.4,0.3l1.8,0.3c0.4,0.1,0.6,0.6,0.3,0.9l-1.3,1.3 c-0.1,0.1-0.2,0.3-0.2,0.5l0.3,1.8c0.1,0.4-0.4,0.8-0.8,0.6l-1.6-0.8c-0.2-0.1-0.3-0.1-0.5,0l-1.6,0.8c-0.4,0.2-0.8-0.1-0.8-0.6 l0.3-1.8c0-0.2,0-0.3-0.2-0.5l-1.3-1.3c-0.3-0.3-0.1-0.8,0.3-0.9l1.8-0.3c0.2,0,0.3-0.1,0.4-0.3l0.8-1.6 C278.8,114,279.4,114,279.6,114.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_189_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.6002,
    y1: -16006.0303,
    x2: 294.9335,
    y2: -15999.1133,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_538_",
    className: "st76",
    d: "M290.8,114.4l0.8,1.6c0.1,0.2,0.2,0.3,0.4,0.3l1.8,0.3c0.4,0.1,0.6,0.6,0.3,0.9l-1.3,1.3 c-0.1,0.1-0.2,0.3-0.2,0.5l0.3,1.8c0.1,0.4-0.4,0.8-0.8,0.6l-1.6-0.8c-0.2-0.1-0.3-0.1-0.5,0l-1.6,0.8c-0.4,0.2-0.8-0.1-0.8-0.6 l0.3-1.8c0-0.2,0-0.3-0.2-0.5l-1.3-1.3c-0.3-0.3-0.1-0.8,0.3-0.9l1.8-0.3c0.2,0,0.3-0.1,0.4-0.3l0.8-1.6 C290,114,290.6,114,290.8,114.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_546_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_190_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.1432,
    y1: 445.7219,
    x2: 214.1432,
    y2: 368.6727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3949B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CA5F7"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_562_",
    x: 207.2,
    y: 377.9,
    className: "st77",
    width: 13.8,
    height: 63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_191_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.3299,
    y1: 445.7219,
    x2: 236.3299,
    y2: 368.6726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3949B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CA5F7"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_561_",
    x: 229.4,
    y: 388,
    className: "st78",
    width: 13.8,
    height: 52.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_192_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.1589,
    y1: 445.7219,
    x2: 192.1589,
    y2: 368.6728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3949B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CA5F7"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_560_",
    x: 185.3,
    y: 396.6,
    className: "st79",
    width: 13.8,
    height: 44.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_193_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.5168,
    y1: 445.7218,
    x2: 258.5168,
    y2: 368.6727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3949B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CA5F7"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_559_",
    x: 251.6,
    y: 369.5,
    className: "st80",
    width: 13.8,
    height: 71.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_194_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.3689,
    y1: -16273.7969,
    x2: 225.3689,
    y2: -16236.6484,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DD5954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0483D"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_554_",
    className: "st81",
    d: "M192.2,391.3c1.9,0,3.4-1.5,3.4-3.4c0-0.5-0.1-1-0.4-1.5l17-16.4c0.5,0.3,1.2,0.5,1.8,0.5 c1,0,1.8-0.4,2.5-1.1l16.3,9.8c0,0.2-0.1,0.3-0.1,0.5c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4c0-0.6-0.2-1.2-0.4-1.7 l17.9-21.3c0.4,0.2,0.8,0.3,1.3,0.3c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4c0,0.7,0.2,1.3,0.5,1.8 l-17.8,21.2c-0.5-0.2-1-0.4-1.5-0.4c-1,0-1.8,0.4-2.5,1.1l-16.3-9.8c0-0.2,0.1-0.3,0.1-0.5c0-1.9-1.5-3.4-3.4-3.4 c-1.9,0-3.4,1.5-3.4,3.4c0,0.5,0.1,0.9,0.3,1.3l-17.1,16.5c-0.5-0.3-1.1-0.4-1.7-0.4c-1.9,0-3.4,1.5-3.4,3.4 C188.8,389.8,190.3,391.3,192.2,391.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_563_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_195_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.6505,
    y1: -16131.7197,
    x2: 473.6505,
    y2: -16101.8789,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_565_",
    className: "st82",
    d: "M484.8,228.5h-22.4c-2.5,0-4.5,2-4.5,4.5v5.6c0,2.5,2,4.5,4.5,4.5h16.2l4.1,4.1 c0.5,0.5,1.4,0.2,1.4-0.6v-3.5h0.7c2.5,0,4.5-2,4.5-4.5V233C489.4,230.5,487.4,228.5,484.8,228.5z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_577_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_539_",
    className: "st0",
    d: "M467.1,235.8c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3 S467.1,235.1,467.1,235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_564_",
    className: "st0",
    d: "M472.4,235.8c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3 S472.4,235.1,472.4,235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_566_",
    className: "st0",
    d: "M477.6,235.8c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3 C477,234.4,477.6,235.1,477.6,235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_567_",
    className: "st0",
    d: "M482.9,235.8c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3 C482.3,234.4,482.9,235.1,482.9,235.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_571_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_196_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.8865,
    y1: -16122.3232,
    x2: 459.8865,
    y2: -16179.4629,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBE1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AED2ED"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_576_",
    className: "st83",
    d: "M446.7,245.4h26.4c2.5,0,4.5,2,4.5,4.5v5.6c0,2.5-2,4.5-4.5,4.5h-20.2l-4.1,4.1 c-0.5,0.5-1.4,0.2-1.4-0.6v-3.5h-0.7c-2.5,0-4.5-2-4.5-4.5V250C442.1,247.4,444.2,245.4,446.7,245.4z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_570_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_575_",
    className: "st0",
    d: "M468.5,252.7c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3 S468.5,252,468.5,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_574_",
    className: "st0",
    d: "M463.2,252.7c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3 S463.2,252,463.2,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_573_",
    className: "st0",
    d: "M457.9,252.7c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3 C458.5,251.4,457.9,252,457.9,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_572_",
    className: "st0",
    d: "M452.6,252.7c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3 C453.2,251.4,452.6,252,452.6,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_579_",
    className: "st0",
    d: "M447.3,252.7c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3 C447.9,251.4,447.3,252,447.3,252.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_60_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_197_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.7954,
    y1: -16069.5029,
    x2: 417.1288,
    y2: -16121.5029,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st84",
    d: "M437.1,223.2h-4c-1.3,0-2.3-1-2.3-2.3v-16.4c0-1.3,1-2.3,2.3-2.3h4c1.3,0,2.3,1,2.3,2.3 v16.4C439.4,222.1,438.4,223.2,437.1,223.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_198_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.2995,
    y1: -16072.6064,
    x2: 433.7997,
    y2: -16113.8555,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st85",
    d: "M463.3,214.7c-0.5,2.8-3.1,3.5-3.1,3.5s1.7,0.2,1.3,1.8c-0.4,1.6-1.9,3.2-3.2,3.2h-10.5 c-1.7,0-3.5-0.3-5.1-1.1c-0.1,0-0.2-0.1-0.3-0.1c-0.7-0.3-1.1-0.9-1.1-1.6v-15.3c0-0.7,0.2-1.4,0.5-2c0.7-1.4,2-3.9,2-5.3 c0-1.9-2.9-8.1-0.9-9.4c2-1.3,4.6,0.4,6.3,3.6c1.4,2.4,0.4,7.8,1.4,8.7h10.2c0,0,2.8-0.1,2.6,2.5c-0.2,2.2-1.4,3.5-1.4,3.5 s1.8-0.1,1.7,2.2c-0.1,2.2-1.8,3.8-1.8,3.8S463.7,212.8,463.3,214.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_199_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.264,
    y1: 323.3052,
    x2: 201.264,
    y2: 345.0681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st86",
    d: "M202.7,346.9h-2.8c-0.9,0-1.6-0.7-1.6-1.6v-11.5c0-0.9,0.7-1.6,1.6-1.6h2.8 c0.9,0,1.6,0.7,1.6,1.6v11.5C204.3,346.1,203.6,346.9,202.7,346.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_200_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.5438,
    y1: 323.3052,
    x2: 213.5438,
    y2: 345.0681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st87",
    d: "M221,341c-0.3,2-2.2,2.4-2.2,2.4s1.2,0.1,0.9,1.3c-0.3,1.2-1.3,2.2-2.2,2.2h-7.4 c-1.2,0-2.4-0.2-3.5-0.7c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.2-0.8-0.6-0.8-1.1v-10.7c0-0.5,0.1-1,0.4-1.4c0.5-1,1.4-2.8,1.4-3.7 c0-1.4-2.1-5.7-0.6-6.6c1.4-0.9,3.2,0.3,4.4,2.5c0.9,1.7,0.3,5.4,1,6.1h7.2c0,0,1.9-0.1,1.8,1.7c-0.1,1.5-1,2.4-1,2.4 s1.3-0.1,1.2,1.6c0,1.6-1.3,2.7-1.3,2.7S221.3,339.6,221,341z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M283.8,146.5h-5.7c-0.4,0-0.7-0.3-0.7-0.7v-5.7c0-0.4,0.3-0.7,0.7-0.7h5.7 c0.4,0,0.7,0.3,0.7,0.7v5.7C284.4,146.2,284.1,146.5,283.8,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M293.2,146.5h-5.7c-0.4,0-0.7-0.3-0.7-0.7v-5.7c0-0.4,0.3-0.7,0.7-0.7h5.7 c0.4,0,0.7,0.3,0.7,0.7v5.7C293.8,146.2,293.5,146.5,293.2,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M302.6,146.5h-5.7c-0.4,0-0.7-0.3-0.7-0.7v-5.7c0-0.4,0.3-0.7,0.7-0.7h5.7 c0.4,0,0.7,0.3,0.7,0.7v5.7C303.2,146.2,302.9,146.5,302.6,146.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st0",
    d: "M97.5,356h-5.7c-0.4,0-0.7-0.3-0.7-0.7v-5.7c0-0.4,0.3-0.7,0.7-0.7h5.7 c0.4,0,0.7,0.3,0.7,0.7v5.7C98.1,355.8,97.8,356,97.5,356z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st0",
    d: "M106.9,356h-5.7c-0.4,0-0.7-0.3-0.7-0.7v-5.7c0-0.4,0.3-0.7,0.7-0.7h5.7 c0.4,0,0.7,0.3,0.7,0.7v5.7C107.5,355.8,107.2,356,106.9,356z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M116.3,356h-5.7c-0.4,0-0.7-0.3-0.7-0.7v-5.7c0-0.4,0.3-0.7,0.7-0.7h5.7 c0.4,0,0.7,0.3,0.7,0.7v5.7C116.9,355.8,116.6,356,116.3,356z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st0",
    d: "M362.4,411.6h-3.7c-0.2,0-0.4-0.2-0.4-0.4v-3.7c0-0.2,0.2-0.4,0.4-0.4h3.7 c0.2,0,0.4,0.2,0.4,0.4v3.7C362.8,411.5,362.6,411.6,362.4,411.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st0",
    d: "M368.4,411.6h-3.7c-0.2,0-0.4-0.2-0.4-0.4v-3.7c0-0.2,0.2-0.4,0.4-0.4h3.7 c0.2,0,0.4,0.2,0.4,0.4v3.7C368.8,411.5,368.6,411.6,368.4,411.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st0",
    d: "M374.4,411.6h-3.7c-0.2,0-0.4-0.2-0.4-0.4v-3.7c0-0.2,0.2-0.4,0.4-0.4h3.7 c0.2,0,0.4,0.2,0.4,0.4v3.7C374.9,411.5,374.7,411.6,374.4,411.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_201_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.1612,
    y1: -16088.5039,
    x2: 424.5127,
    y2: -16088.5039,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6DFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDEAF7"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st88",
    d: "M342.8,206.6L342.8,206.6c0,5.4,4.4,9.9,9.9,9.9h61.4c5.4,0,9.9-4.4,9.9-9.9l0,0 c0-5.4-4.4-9.9-9.9-9.9h-61.4C347.2,196.8,342.8,201.2,342.8,206.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_202_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.2681,
    y1: -16075.6514,
    x2: 356.3931,
    y2: -16096.6514,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6DFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDEAF7"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st89",
    d: "M412.4,203.2H371c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1h41.3 c0.6,0,1.1,0.5,1.1,1.1l0,0C413.4,202.8,413,203.2,412.4,203.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_203_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.9749,
    y1: -16078.1563,
    x2: 354.0999,
    y2: -16099.1563,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6DFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDEAF7"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    className: "st90",
    d: "M396.8,207.7H371c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1h25.8 c0.6,0,1.1,0.5,1.1,1.1l0,0C397.8,207.2,397.4,207.7,396.8,207.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_204_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.5654,
    y1: -16085.4189,
    x2: 356.6904,
    y2: -16106.4189,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6DFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDEAF7"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st91",
    d: "M412.4,207.7h-11c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1h11 c0.6,0,1.1,0.5,1.1,1.1l0,0C413.4,207.2,413,207.7,412.4,207.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_205_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.2144,
    y1: -16082.1543,
    x2: 352.3393,
    y2: -16103.1543,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6DFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDEAF7"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st92",
    d: "M390.6,212.2H371c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1h19.6 c0.6,0,1.1,0.5,1.1,1.1l0,0C391.7,211.7,391.2,212.2,390.6,212.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_37_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_206_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.6524,
    y1: -16099.3662,
    x2: 357.6524,
    y2: -16088.6152,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st93",
    d: "M357.7,205.9L357.7,205.9c-2.9,0-5.3,2.4-5.3,5.3v0.5c0,0.2,0.2,0.4,0.4,0.4h9.7 c0.2,0,0.4-0.2,0.4-0.4v-0.5C362.9,208.3,360.6,205.9,357.7,205.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_207_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.6524,
    y1: -16087.3477,
    x2: 357.6524,
    y2: -16076.5977,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st94",
    d: "M359.9,202.8c0,1.2-1,2.8-2.2,2.8c-1.2,0-2.2-1.6-2.2-2.8c0-1.2,1-2.2,2.2-2.2 C358.9,200.5,359.9,201.5,359.9,202.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_62_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_89_"
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_96_",
    className: "st0",
    d: "M55.7,249.8L55.7,249.8c0,5.3,4.3,9.5,9.5,9.5h59.5c5.3,0,9.5-4.3,9.5-9.5l0,0 c0-5.3-4.3-9.5-9.5-9.5H65.3C60,240.2,55.7,244.5,55.7,249.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_208_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.9412,
    y1: -16118.8223,
    x2: 68.0662,
    y2: -16139.8223,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6DFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDEAF7"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_95_",
    className: "st95",
    d: "M124,246.4H82.7c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1H124 c0.6,0,1.1,0.5,1.1,1.1l0,0C125.1,245.9,124.6,246.4,124,246.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_209_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.648,
    y1: -16121.3271,
    x2: 65.773,
    y2: -16142.3271,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6DFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDEAF7"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_94_",
    className: "st96",
    d: "M108.5,250.9H82.7c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1h25.8 c0.6,0,1.1,0.5,1.1,1.1l0,0C109.5,250.4,109,250.9,108.5,250.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_212_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.2385,
    y1: -16128.5898,
    x2: 68.3636,
    y2: -16149.5898,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6DFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDEAF7"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    className: "st97",
    d: "M124,250.9h-11c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1h11 c0.6,0,1.1,0.5,1.1,1.1l0,0C125.1,250.4,124.6,250.9,124,250.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_216_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.8875,
    y1: -16125.3252,
    x2: 64.0124,
    y2: -16146.3252,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6DFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDEAF7"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    className: "st98",
    d: "M102.3,255.3H82.7c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1h19.6 c0.6,0,1.1,0.5,1.1,1.1l0,0C103.4,254.9,102.9,255.3,102.3,255.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_65_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_254_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.638,
    y1: 243.8885,
    x2: 70.638,
    y2: 258.8263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st99",
    d: "M70.6,249.1L70.6,249.1c-2.9,0-5.3,2.4-5.3,5.3v0.5c0,0.2,0.2,0.4,0.4,0.4h9.7 c0.2,0,0.4-0.2,0.4-0.4v-0.5C75.9,251.5,73.6,249.1,70.6,249.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_256_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.638,
    y1: 243.8885,
    x2: 70.638,
    y2: 258.8264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51B9F8"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    className: "st100",
    d: "M72.9,245.9c0,1.2-1,2.8-2.2,2.8s-2.2-1.6-2.2-2.8c0-1.2,1-2.2,2.2-2.2 S72.9,244.7,72.9,245.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_261_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.3523,
    y1: -16083.0977,
    x2: 291.2259,
    y2: -16040.2246,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F8FF"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st101",
    d: "M256.4,196.4c-1.7-1.5-3.9-1.1-5.3-0.3c-1.4,0.8-2.1,2-2.1,2s-0.8-1.2-2.1-2 c-1.4-0.8-3.5-1.2-5.3,0.3c-4.1,3.6,2,12.3,7.4,14.2C254.3,208.7,260.5,200.1,256.4,196.4z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st0",
    d: "M117.9,263.6c-1.5-1.3-3.3-0.9-4.5-0.3c-1.2,0.7-1.8,1.7-1.8,1.7s-0.6-1-1.8-1.7 c-1.2-0.7-3-1.1-4.5,0.3c-3.5,3.1,1.8,10.5,6.3,12.2C116.1,274.1,121.4,266.7,117.9,263.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_265_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.8947,
    y1: 127.4302,
    x2: 201.8947,
    y2: 142.8377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DD786F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DB5E55"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st102",
    d: "M206,133.3c-1-0.9-2.1-0.6-2.9-0.2c-0.8,0.4-1.2,1.1-1.2,1.1s-0.4-0.7-1.2-1.1 c-0.8-0.4-2-0.7-2.9,0.2c-2.3,2,1.1,6.9,4.1,7.9C204.9,140.2,208.3,135.3,206,133.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_267_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.7896,
    y1: 180.0552,
    x2: 533.7896,
    y2: 215.7468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DD786F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9154,
    style: {
      stopColor: "#DB6057"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DB5E55"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st103",
    d: "M544.7,187.7c-2.6-2.3-5.7-1.6-7.8-0.4c-2,1.2-3.1,2.9-3.1,2.9s-1.1-1.8-3.1-2.9 c-2.1-1.2-5.2-1.8-7.8,0.4c-6.1,5.3,3,18.1,10.9,21C541.7,205.9,550.8,193.1,544.7,187.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_61_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_59_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_271_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.9818,
    y1: 170.8052,
    x2: 304.9818,
    y2: 209.0683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_67_",
    className: "st104",
    cx: 305,
    cy: 187.9,
    r: 20.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_66_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -43.5127 270.6787)",
    className: "st105",
    cx: 305,
    cy: 187.9,
    rx: 17.4,
    ry: 17.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_272_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.4796,
    y1: -16088.2559,
    x2: 320.5898,
    y2: -16054.1455,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAE080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4BB58"
    }
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_64_",
    className: "st106",
    cx: 305,
    cy: 187.9,
    r: 16.7
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_70_",
    className: "st105",
    d: "M309.7,180.4l-0.3-0.2c-0.7-0.4-1.5-0.7-2.4-0.9c-0.6-0.1-1-0.6-1-1.2v-0.4 c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.6-1.2,1.2v0.7c0,0.5-0.3,1-0.8,1.1c-2,0.7-3.3,2.4-3.3,4.5c0,2.8,2.3,4.1,4.7,5.1 c2,0.8,2.8,1.7,2.8,2.9c0,1.3-1.2,2.3-2.9,2.3c-1.3,0-2.7-0.4-3.7-1.1l-0.4-0.3c0,0-1.3-0.7-1.8,0.7c-0.4,1,0.9,1.8,0.9,1.8 l0.2,0.2c0.7,0.5,1.8,0.9,3,1.1c0.6,0.1,1,0.6,1,1.2v0.5c0,0.7,0.5,1.2,1.2,1.2h0c0.7,0,1.2-0.6,1.2-1.2v-0.8 c0-0.5,0.3-1,0.8-1.1c2.1-0.8,3.5-2.5,3.5-4.7c0-2.5-1.3-4.1-4.5-5.3c-2.4-1-3.1-1.6-3.1-2.8c0-0.9,0.7-2,2.5-2 c1.7,0,2.8,0.6,3.2,0.9l0.4,0.2c0,0,1.3,0.8,1.9-0.7C311,181.2,309.7,180.4,309.7,180.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_68_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_274_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.5831,
    y1: 299.8885,
    x2: 92.5831,
    y2: 324.6653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_77_",
    className: "st107",
    cx: 92.6,
    cy: 312.4,
    r: 13.2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_75_",
    transform: "matrix(0.5969 -0.8023 0.8023 0.5969 -213.2807 200.1783)",
    className: "st105",
    cx: 92.6,
    cy: 312.4,
    rx: 11.1,
    ry: 11.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_275_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.769,
    y1: -16206.0566,
    x2: 102.5493,
    y2: -16184.2764,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAE080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4BB58"
    }
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_73_",
    className: "st108",
    cx: 92.6,
    cy: 312.4,
    r: 10.7
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    className: "st105",
    d: "M95.6,307.6l-0.2-0.1c-0.5-0.3-1-0.5-1.5-0.6c-0.4-0.1-0.6-0.4-0.6-0.8V306 c0-0.4-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v0.4c0,0.3-0.2,0.6-0.5,0.7c-1.3,0.5-2.1,1.5-2.1,2.9c0,1.8,1.5,2.6,3,3.2 c1.3,0.5,1.8,1.1,1.8,1.8c0,0.9-0.8,1.5-1.8,1.5c-0.8,0-1.7-0.3-2.4-0.7l-0.3-0.2c0,0-0.8-0.5-1.2,0.5c-0.2,0.7,0.6,1.2,0.6,1.2 l0.2,0.1c0.5,0.3,1.2,0.6,1.9,0.7c0.4,0.1,0.7,0.4,0.7,0.8v0.3c0,0.4,0.4,0.8,0.8,0.8h0c0.4,0,0.8-0.4,0.8-0.8v-0.5 c0-0.3,0.2-0.6,0.5-0.7c1.4-0.5,2.2-1.6,2.2-3c0-1.6-0.9-2.6-2.8-3.4c-1.6-0.6-2-1-2-1.8c0-0.6,0.4-1.3,1.6-1.3 c1.1,0,1.8,0.4,2.1,0.6l0.2,0.1c0,0,0.9,0.5,1.2-0.5C96.4,308.1,95.6,307.6,95.6,307.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_78_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_276_",
    gradientUnits: "userSpaceOnUse",
    x1: 571.1762,
    y1: 294.4302,
    x2: 571.1762,
    y2: 323.4326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA900"
    }
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_82_",
    className: "st109",
    cx: 571.2,
    cy: 308.7,
    r: 17.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_81_",
    className: "st105",
    cx: 571.2,
    cy: 308.7,
    r: 14.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_277_",
    gradientUnits: "userSpaceOnUse",
    x1: 555.8244,
    y1: -16205.9902,
    x2: 584.1267,
    y2: -16177.6885,
    gradientTransform: "matrix(1 0 0 -1 0 -15881.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAE080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4BB58"
    }
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_80_",
    className: "st110",
    cx: 571.2,
    cy: 308.7,
    r: 13.8
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    className: "st105",
    d: "M575.1,302.6l-0.2-0.1c-0.6-0.3-1.2-0.6-2-0.7c-0.5-0.1-0.8-0.5-0.8-1v-0.3 c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1v0.6c0,0.4-0.3,0.8-0.7,1c-1.7,0.6-2.7,2-2.7,3.7c0,2.3,1.9,3.4,3.9,4.2 c1.7,0.7,2.4,1.4,2.4,2.4c0,1.1-1,1.9-2.4,1.9c-1.1,0-2.2-0.3-3.1-0.9l-0.3-0.2c0,0-1.1-0.6-1.5,0.6c-0.3,0.9,0.8,1.5,0.8,1.5 l0.2,0.1c0.6,0.4,1.5,0.8,2.5,0.9c0.5,0.1,0.9,0.5,0.9,1v0.4c0,0.6,0.5,1,1,1h0c0.6,0,1-0.5,1-1V317c0-0.4,0.3-0.8,0.7-0.9 c1.8-0.6,2.9-2.1,2.9-3.9c0-2-1.1-3.4-3.7-4.4c-2-0.8-2.6-1.3-2.6-2.3c0-0.8,0.5-1.6,2.1-1.6c1.4,0,2.3,0.5,2.7,0.7l0.3,0.2 c0,0,1.1,0.7,1.6-0.6C576.2,303.2,575.1,302.6,575.1,302.6z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_26_",
    className: "st111",
    x1: 65.3,
    y1: 441,
    x2: 584.8,
    y2: 441
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 217.8872 288.054)",
    className: "st13 st112 st113"
  }, "CRM")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.2d816b75e8b954da6e30e6df2c26638a.svg";
export { ForwardRef as ReactComponent };